import angular from 'angular';
import translate from 'angular-translate';
import translateUrl from 'angular-translate-loader-url';
import localStorage from '../localstorage';
import tenantConfig from '../tenant-config';
import config from './config';
import controller from './controller';
import service from './service';

const app = angular.module('klTranslation', ['pascalprecht.translate', translateUrl, localStorage, tenantConfig]);

config(app);
controller(app);
service(app);

export default app.name;
